$(document).ready(function () {
    moveApsSearch();
});

$(window).resize(function() {
    moveApsSearch();
});

function moveApsSearch() {
    var win = $(window).width();
    if (win > 992) {
        $('.gv-mmy-bar').appendTo($('#gv-aps-desktop'));  
    } else {
        $('.gv-mmy-bar').appendTo($('#gv-aps-mobile'));  
    }
};